import { QueryClientProvider } from '@tanstack/react-query';
import { Suspense, lazy, type ReactNode } from 'react';

import { queryClient } from '@/app/query-client';
import { Toaster } from '@/components/ui';
import { env } from '@/lib/env';

/**
 * Devtools are code-split and only ever rendered in development, so they never
 * reach the production bundle.
 */
const ReactQueryDevtools = lazy(() =>
  import('@tanstack/react-query-devtools').then((mod) => ({ default: mod.ReactQueryDevtools })),
);

/** One-click role switching while developing. Same guard, same reasoning. */
const DevSignIn = lazy(() =>
  import('@/components/dev/dev-sign-in').then((mod) => ({ default: mod.DevSignIn })),
);

interface ProvidersProps {
  children: ReactNode;
}

/**
 * Every app-wide context in one place, so `main.tsx` stays a few lines and the
 * provider order is visible.
 */
export function Providers({ children }: ProvidersProps) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <Toaster />
      {env.isDevelopment && (
        <Suspense fallback={null}>
          <ReactQueryDevtools initialIsOpen={false} />
          <DevSignIn />
        </Suspense>
      )}
    </QueryClientProvider>
  );
}
